import * as SystemHealthEquipmentActions from '@actions/get-system-health-equipment/get-system-health-equipment.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { DashletSettingsService } from '@services/index';

@Injectable()
export class GetSystemHealthEquipmentEffects {
    constructor(private actions$: Actions, private settingsService: DashletSettingsService) {}

    getSystemHealthEquipment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SystemHealthEquipmentActions.GetSystemHealthEquipments),
            mergeMap(action =>
                this.settingsService.getSystemHealthEquipment(action.entityId).pipe(
                    catchError(err =>
                        of(SystemHealthEquipmentActions.GetSystemHealthEquipmentsFailure({ error: err }))
                    ),
                    mergeMap((data: any) => [
                        SystemHealthEquipmentActions.GetSystemHealthEquipmentsSuccess({
                            data: data,
                            entityId: action.entityId
                        })
                    ])
                )
            )
        )
    );
}
